//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.ServiceOrientedFeatureCurveBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.CurveSettings.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AccuracyType",1,0],[1,"Angle",0,"Expression",0],[0,"BeamDirection",1,"Direction",0],[0,"ClippingBody",1,"ScCollector",0],[0,"ClippingType",1,0],[0,"CurveLocationFaces",1,"ScCollector",0],[0,"CurveLocationPlane",1,"Plane",0],[0,"CurveLocationType",1,0],[0,"CurveSettings",1,"GeometricUtilities.CurveSettings",0],[0,"DistanceThreshold",1,0],[0,"EnableShadowRange",1,0],[1,"HalfAngle",0,"Expression",0],[0,"LightSourceType",1,0],[0,"MaskBodyProcessingTypes",1,0],[0,"MaskType",1,0],[0,"MaskingBodies",1,"ScCollector",0],[0,"MaskingCurves",1,"Section",0],[0,"OptimizeCurveFlag",1,0],[0,"OriginPoint",1,"Point",0],[0,"RayDirection",1,"Direction",0],[1,"ShadowRangeOnPlane",0,"Expression",0],[1,"SphereDiameter",0,"Expression",0],[0,"UnassociativeMaskingBodiesFromAssembly",1,"ScCollector",0],[0,"UpVector",1,"Direction",0],[1,"VerticalAngle",0,"Expression",0],[1,"VerticalHalfAngle",0,"Expression",0],[1,"WidthAngle",0,"Expression",0],[1,"WidthHalfAngle",0,"Expression",0]],[],[]];
SPLM.Features.ShadowCurveBuilder = class extends SPLM.Features.ServiceOrientedFeatureCurveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShadowCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShadowCurveBuilder.LightSourceTypes = Object.freeze({
    "Vector" : "Vector", "Point" : "Point"});

SPLM.Features.ShadowCurveBuilder.MaskTypes = Object.freeze({
    "Bodies" : "Bodies", "Curves" : "Curves", "AssemblyUnassociativeOnly" : "AssemblyUnassociativeOnly"});

SPLM.Features.ShadowCurveBuilder.ClippingTypes = Object.freeze({
    "None" : "None", "Cone" : "Cone", "Pyramid" : "Pyramid", "Body" : "Body"});

SPLM.Features.ShadowCurveBuilder.CurveLocationTypes = Object.freeze({
    "SilhouetteCurve" : "SilhouetteCurve", "ShadowonPlane" : "ShadowonPlane", "ShadowonFace" : "ShadowonFace", "ShadowonSphere" : "ShadowonSphere"});

SPLM.Features.ShadowCurveBuilder.AccuracyTypes = Object.freeze({
    "UltraFine" : "UltraFine", "Fine" : "Fine", "Standard" : "Standard", "Course" : "Course", "Rough" : "Rough"});

SPLM.Features.ShadowCurveBuilder.MaskBodyProcessingType = Object.freeze({
    "FasterResult" : "FasterResult", "MorePreciseResult" : "MorePreciseResult"});

export default SPLM;